import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { ServiceWorkerService } from './core/services/serviceworker.service';
import { DkGlobalLoaderComponent } from './shared/components/dk-global-loader/dk-global-loader.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, Toast, DkGlobalLoaderComponent],
    templateUrl: './app.html',
    styleUrl: './app.scss',
})
export class App {
    private readonly swService = inject(ServiceWorkerService);
    
    testSentryError() {
        throw new Error('Test Sentry Error');
    }
}